import { render, staticRenderFns } from "./AppSelectSchool.vue?vue&type=template&id=476e1e15&"
import script from "./AppSelectSchool.vue?vue&type=script&lang=js&"
export * from "./AppSelectSchool.vue?vue&type=script&lang=js&"
import style0 from "../../styles/_reservation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports